import { CSSProperties } from "react";

interface HairlineProps {
  dashed?: boolean;
  style?: CSSProperties;
}

export function Hairline({ dashed, style }: HairlineProps) {
  return <div className={dashed ? "hair-dash" : "hair"} style={{ width: "100%", ...style }} />;
}
